import React from "react";
import "./assets/scss/styles.scss";
import { connect } from "react-redux";
import PublicAppContainer from "./public-app/PublicAppContainer";
import PrivateAppContainer from "./private-app/PrivateAppContainer";

const App: React.FC<any> = (props) => {
  const WrapperComponent = props.isAuthenticated
    ? PrivateAppContainer
    : PublicAppContainer;
  return <WrapperComponent>{props.children}</WrapperComponent>;
};

const mapStateToProps = (state: any) => ({
  isAuthenticated: state.isAuthenticated,
});

export default connect(mapStateToProps)(App);
